"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultRules = void 0;

function isNotNullOrUndefined(obj) {
  return obj !== undefined && obj !== null;
}

function basicToString(obj) {
  return isNotNullOrUndefined(obj) ? "".concat(obj) : '';
}

var DefaultRules = {
  'string': function string(data) {
    return basicToString(data);
  }
};
exports.DefaultRules = DefaultRules;